import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import SprintInfo from "./component/sprintInfo/page";
import StorySummary from "./component/StorySummary/page";
import SprintProgress from "./component/SprintProgress/page";
import TaskStatus from "./component/TaskStatus/page";
import TaskPlanning from "./component/TaskPlanning/page";

const SummaryReport = () => {
  

  return (
    <Container fluid className="p-1">
      <h4 className="fw-semibold">
        Summary Report
      </h4>

      <Row className="mt-1 g-3">
        <Col md={4}>
          <SprintInfo />
        </Col>

        <Col md={8}>
          <Row className="g-3">
            <Col md={12}>
              <StorySummary />
            </Col>
            <Col md={12}>
              <SprintProgress />
            </Col>
          </Row>
        </Col>

      </Row>

      <Row className="mt-3 g-3">
        <Col md={12}>
          <TaskStatus />
        </Col>
      </Row>
     
      <Row className="mt-3 g-3 mb-4">      
        <Col md={12}>
          <TaskPlanning />
        </Col>
      </Row>

    </Container>
  );
};
export default SummaryReport;
